// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2QSLE","inputWrap":"CustomTip_inputWrap__qYdWR"};